import React from 'react'
import {Container, Row, Col, Button} from "react-bootstrap"
import {Link, useHistory} from "react-router-dom"
import LightSpeed from 'react-reveal/LightSpeed';

import MountainBike from "../../style/Img/Bici/Mountain Bike.jpg"
import BiciCorsa from "../../style/Img/Bici/Bici da Corsa.jpg"
import BiciPasseggio from "../../style/Img/Bici/Bici da Passeggio.jpg"




function ListaBici() {
    let history = useHistory();

    return (
        <Container fluid>
            {/* SEZIONE BANNER */}
            <Container fluid id="banner_recovered" className="head-banner text-center text-white">
            <Container>
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>
        </Container>

        {/* SEZIONE INTRODUZIONE */}
        <Container className=" text-center mt-3">
            
            <h2><strong>Catalogo Motocicli</strong></h2>
            <h3>I nostri motocicli disponibili al noleggio 24/7</h3>
            
        </Container>

        {/* SEZIONE AUTOMOBILI */}
        <Container className="mt-4">
            <Row>
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Mountain Bike"}>
                <img className="d-block w-100" src={MountainBike} alt="Mountain Bike" />
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Mountain Bike</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        1€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Mountain Bike")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Bici da Passeggio"}>
                <img className="d-block w-100" src={BiciPasseggio} alt="Bici da Passeggio" />
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Bici da Passeggio</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        1€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Bici da Passeggio")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Bici da Corsa"}>
                <img className="d-block w-100" src={BiciCorsa} alt="Bici da Corsa" />
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Bici da Corsa</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        1€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Bici da Corsa")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>
        </Container>
        </Container>
    )
}

export default ListaBici